//
//
//
//
//
//

import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'

export default {
    name: 'Posture_front',
    directive: {
        bModalDirective
    },
    components: {

    },
    props : [
        'severeRisks',
        'mildRisks',
        'normalRisks',
        'points',
        'photos'
    ],
    data(){
        return {
            img: {
              face: null,
              side: null
            },
        };
    },
    computed: {

    },
   methods: {
      getRiskImg(risk){
        //.log("risk ==>" + JSON.stringify(risk))
        let direction = 'normal';
        let img;

        if(!_.isNull( risk.direction) && risk.key !== 'legO' && risk.key !== 'legX' && risk.key !== 'legXO' && risk.key !== 'kneeOverstretch'){
          direction = risk.direction
        }
        if(this.checkIfAbnormal(risk.level)){
          img = risk.abnormal[direction];
        }else{
          img = risk.normal[direction];
        }
        return img;
      },
      setSymptomCanvasModal (risk) {
        let points = this.points
        let needDetail = ['legO', 'legX', 'legXO']
        let forSide = ['headLean', 'roundShoulder', 'kneeOverstretch']

        let riskKey = risk.key
        let keyMap = this.keyMap
        let positionArr
        let positionPointsArr = []
        let faceOrSide
        let scale



        Object.keys(keyMap).forEach(function (direction, index) {
          Object.keys(keyMap[direction]).forEach(function (key, index) {
            if (key === riskKey) {
              positionArr = keyMap[direction][key].position
              scale = keyMap[direction][key].scale
            }
          })
        })



        if (needDetail.indexOf(riskKey) !== -1) {
          // 当是 legO、legX、legXO 时
          let lOrR
          if (risk.detail === '右腿') {
            lOrR = 'right'
          } else {
            lOrR = 'left'
          }

          for (let i = 0; i < positionArr.length; i++) {
            positionPointsArr.push(points.face[positionArr[i]][lOrR])
          }

          faceOrSide = 'face'
        }
        else {
          // 正面，并且能取到左右时
          for (let i = 0; i < positionArr.length; i++) {
            let positionAndDirectionArr = positionArr[i].split('-')
            if (positionAndDirectionArr.length === 1) {
              positionPointsArr.push(points.face[positionAndDirectionArr[0]])
            } else {
              positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]])
            }
          }
          faceOrSide = 'face'
        }



        let _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x)
        let _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y)
        let xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2
        let yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2

        let width = _x > _y ? _x : _y
        width *= (1 + scale)

        let x = xMid - width / 2
        let y = yMid - width / 2


        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        canvas.style.width = '100%'
        canvas.style.height = '100%'
        canvas.width = width
        canvas.height = width
        // let img = new Image();
        // img.src = this.photos[faceOrSide];

        let img = this.img[faceOrSide]

        ctx.drawImage(img, x, y, width, width, 0, 0, width, width)


        this.canvas = canvas
      },
      setSymptomCanvas (option) {
        let canvas = option.el
        let ctx = canvas.getContext('2d')

        let points = this.points
        let needDetail = ['legO', 'legX', 'legXO']
        let forSide = ['headLean', 'roundShoulder', 'kneeOverstretch']

        let riskKey = canvas.dataset.key
        let keyMap = this.keyMap
        let positionArr
        let positionPointsArr = []
        let faceOrSide
        let scale
        Object.keys(keyMap).forEach(function (direction, index) {
          Object.keys(keyMap[direction]).forEach(function (key, index) {
            if (key === riskKey) {
              positionArr = keyMap[direction][key].position
              scale = keyMap[direction][key].scale
            }
          })
        })



        if (needDetail.indexOf(riskKey) !== -1) {
          // 当是 legO、legX、legXO 时
          let lOrR
          if (canvas.dataset.detail === '右腿') {
            lOrR = 'right'
          } else {
            lOrR = 'left'
          }

          for (let i = 0; i < positionArr.length; i++) {
            positionPointsArr.push(points.face[positionArr[i]][lOrR])
          }

          faceOrSide = 'face'
        } else {
          // 正面，并且能取到左右时
          for (let i = 0; i < positionArr.length; i++) {
            let positionAndDirectionArr = positionArr[i].split('-')
            if (positionAndDirectionArr.length === 1) {
              positionPointsArr.push(points.face[positionAndDirectionArr[0]])
            } else {
              positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]])
            }
          }

          faceOrSide = 'face'
        }



        let _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x)
        let _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y)
        let xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2
        let yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2

        let width = _x > _y ? _x : _y
        width *= (1 + scale)

        let x = xMid - width / 2
        let y = yMid - width / 2


        canvas.style.width = '100%'
        canvas.style.height = '100%'
        canvas.width = width
        canvas.height = width
        let img = new Image();
        img.src = this.photos[faceOrSide];
        // img.src = this.img[faceOrSide]
        img.onload=function(){
          ctx.drawImage(img, x, y, width, width, 0, 0, width, width)
        }

      },

      getLevel (level) {
        switch (level) {
          case this.level.normal:
            return {
              des: '低风险',
              className: 'level-normal'
            }
          case this.level.mild:
            return {
              des: '中风险',
              className: 'level-mild'
            }
          case this.level.severe:
            return {
              des: '高风险',
              className: 'level-severe'
            }
        }
      },
      checkIfAbnormal(level) {
        switch (level) {
          case this.level.normal:
            return false
          case this.level.mild:
            return false
          case this.level.severe:
            return true
        }
      },
      sortHighToLow (arr) {
        return _.orderBy(arr, ['value'], ['desc'])
      },
      initRiskBar () {
        this.$refs.riskModalRef.$el.getElementsByClassName('modal-content')[0].scrollTop = 0
        let modalRiskBar = document.getElementById('modalRiskBar')
        canvas.initRiskLevel({
          el: modalRiskBar,
          width: Number(modalRiskBar.parentNode.offsetWidth),
          height: Number(modalRiskBar.parentNode.offsetHeight),
          color: {
            normal: '#00d963',
            mild: '#ffbf00',
            severe: '#ff4d4d'
          },
          level: this.level
        })
      },
      initRisksData () {
        let risks = this.risks
        let level = this.level
        let symptoms = this.symptoms
        let normalRisks =this.normalRisks;
        let mildRisks =this.mildRisks;
        let severeRisks =this.severeRisks;

        for (let direction in risks) {
          for (let i = 0; i < risks[direction].length; i++) {
            let symptom = symptoms[risks[direction][i].position][risks[direction][i].code - 1]

            if (symptom.value) {
              let otherSymptom = Object.assign({}, symptom)
              if (!risks[direction][i].valid) {
                otherSymptom.raw = 0
                otherSymptom.value = 0
                otherSymptom.level = level.normal
                otherSymptom.detail = ''
                otherSymptom.direction = 'normal'
              } else {
                otherSymptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0
                otherSymptom.value = risks[direction][i].value ? risks[direction][i].value : 0
                otherSymptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal
                otherSymptom.detail = risks[direction][i].detail ? risks[direction][i].detail : ''
                otherSymptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal'
              }

              symptoms[risks[direction][i].position].push(otherSymptom)
            } else {
              if (!risks[direction][i].valid) {
                symptom.raw = 0
                symptom.value = 0
                symptom.level = level.normal
                symptom.detail = ''
                symptom.direction = 'normal'
              } else {
                symptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0
                symptom.value = risks[direction][i].value ? risks[direction][i].value : 0
                symptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal
                symptom.detail = risks[direction][i].detail ? risks[direction][i].detail : ''
                symptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal'
              }
            }
          }
        }

        for (let position in symptoms) {
          for (let i = 0; i < symptoms[position].length; i++) {
            if (_.isUndefined(symptoms[position][i].value)) {
              continue
            }
            switch (symptoms[position][i].level) {
              case level.normal:
                normalRisks.push(symptoms[position][i])
                break
              case level.mild:
                mildRisks.push(symptoms[position][i])
                break
              case level.severe:
                severeRisks.push(symptoms[position][i])
                break
              default:
                normalRisks.push(symptoms[position][i])
                break
            }
          }
        }

        this.normalRisks = this.sortHighToLow(normalRisks)
        this.mildRisks = this.sortHighToLow(mildRisks)
        this.severeRisks = this.sortHighToLow(severeRisks)





      },
      initRiskPoints () {
        let that = this
        let points = this.points
        let photos = this.photos
        let faceCanvas = document.createElement('canvas')
        let _this = this

        // === 初始化正面数据 ===
        let facePointsArr = []
        let face = points.face
        let faceImg = new Image()

        // 人体骨架分组

        // 生成两个中点：1、左右骨盆连线中点； 2、骨盆中点和脖子连线的中点
        let hipRPoint = face['hip']['right']
        let hipLPoint = face['hip']['left']
        let neckPoint = face['neck']
        let hipMPoint = {
          x: 0,
          y: 0
        }
        let hipAndNeckMPoint = {
          x: 0,
          y: 0
        }
        if ((hipLPoint.x === 0 && hipLPoint.y === 0) || (hipRPoint.x === 0 && hipRPoint.y === 0)) {

        } else {
          // 计算左右骨盆连线中点
          hipMPoint.x = (hipLPoint.x + hipRPoint.x) / 2
          hipMPoint.y = (hipLPoint.y + hipRPoint.y) / 2

          // 计算骨盆中点和脖子连线的中点
          if (!(neckPoint.x === 0 && neckPoint.y === 0)) {
            hipAndNeckMPoint.x = (neckPoint.x + hipMPoint.x) / 2
            hipAndNeckMPoint.y = (neckPoint.y + hipMPoint.y) / 2
          }
        };

        face.hipM = hipMPoint
        face.hipAndNeckM = hipAndNeckMPoint

        let faceOrder = [
          ['ear-right', 'eye-right', 'nose', 'eye-left', 'ear-left'],
          ['wrist-right', 'elbow-right', 'shoulder-right', 'neck', 'shoulder-left', 'elbow-left', 'wrist-left'],
          // ['ankle-right', 'knee-right', 'hip-right', 'neck', 'hip-left', 'knee-left', 'ankle-left'],
          ['ankle-right', 'knee-right', 'hip-right', 'hipM', 'hip-left', 'knee-left', 'ankle-left'],
          ['neck', 'hipAndNeckM', 'hipM'],
          ['nose', 'neck']
        ]

        // 垂直标准线
        let verticalStandard = ['shoulder-right', 'ankle-middle', 'shoulder-left']
        let verticalPointsArr = []

        // 症状和位置对应
        let risks = this.normalRisks.concat(this.mildRisks, this.severeRisks)


        let faceSymptomWithPosition = ['headSidesway-ear', 'highLowShoulder-shoulder', 'spineSidesway', 'pelvisLean-hip', 'legO-knee', 'legX-knee', 'legXO-knee']
        let faceHorizontalArr = []

        for (let i = 0; i < faceSymptomWithPosition.length; i++) {
          let symptomWithPositionArr = faceSymptomWithPosition[i].split('-')
          let pointsAndAngle = {
            key: symptomWithPositionArr[0]
          }

          for (let j = 0; j < risks.length; j++) {
            if (risks[j].key === symptomWithPositionArr[0]) {
              if (!_.isUndefined(pointsAndAngle.raw)) {
                pointsAndAngle.secondRaw = risks[j].raw
              } else {
                pointsAndAngle.raw = risks[j].raw
                if (symptomWithPositionArr.length === 1) {
                  pointsAndAngle.points = [face['elbow'].left]
                } else {
                  pointsAndAngle.points = [face[symptomWithPositionArr[1]].right, face[symptomWithPositionArr[1]].left]
                }
              }
            }
          }

          if (_.isUndefined(pointsAndAngle.raw) || _.isUndefined(pointsAndAngle.points)) {
            continue
          } else {
            faceHorizontalArr.push(pointsAndAngle)
          }
        }



        // 先将各分组数据点取出来
        for (let i = 0; i < faceOrder.length; i++) {
          let pointsArr = []
          for (let j = 0; j < faceOrder[i].length; j++) {
            let positionArr = faceOrder[i][j].split('-')
            if (positionArr.length === 1) {
              pointsArr.push(face[positionArr[0]])
            } else {
              pointsArr.push(face[positionArr[0]][positionArr[1]])
            }
          }
          facePointsArr.push(pointsArr)
        }

        // 将垂直标准点取出来
        for (let i = 0; i < verticalStandard.length; i++) {
          let positionArr = verticalStandard[i].split('-')

          // 该部分是含过 nose 的标准线
          // if(positionArr.length === 1) {
          //   verticalPointsArr.push(face[positionArr[0]]);
          // } else {
          //   verticalPointsArr.push(face[positionArr[0]][positionArr[1]])
          // }

          // 该部分是过两边足踝中点的标准线
          if (positionArr[1] === 'middle') {
            if ((face[positionArr[0]].left.x === 0 && face[positionArr[0]].left.y === 0) ||
              (face[positionArr[0]].right.x === 0 && face[positionArr[0]].right.y === 0)) {
              verticalPointsArr.push({
                x: 0,
                y: 0
              })
            } else {
              verticalPointsArr.push({
                x: (face[positionArr[0]].left.x + face[positionArr[0]].right.x) / 2,
                y: 0
              })
            }
          } else {
            verticalPointsArr.push(face[positionArr[0]][positionArr[1]])
          }
        }



        // 开始画图以及各点线
        faceImg.src = photos.face
        faceImg.onload = function () {
          that.img.face = faceImg
          // 将图片画进 canvas
          let width = faceImg.width
          let height = faceImg.height
          faceCanvas.width = width
          faceCanvas.height = height
          faceCanvas.style.width = '100%'

          let cxt = faceCanvas.getContext('2d')
          cxt.drawImage(faceImg, 0, 0, width, height)
          // 按分组画线
          for (let i = 0; i < facePointsArr.length; i++) {
            for (let j = 0; j < facePointsArr[i].length; j++) {
              if (j === 0 || (facePointsArr[i][j].x === 0 && facePointsArr[i][j].y === 0) ||
                (facePointsArr[i][j - 1].x === 0 && facePointsArr[i][j - 1].y === 0)) {
                if (facePointsArr[i][j].x === 0 && facePointsArr[i][j].y === 0) {
                  continue
                } else {
                  _this.drawPoint({
                    el: faceCanvas,
                    point: facePointsArr[i][j]
                  })
                  continue
                }
              } else {
                _this.drawPoint({
                  el: faceCanvas,
                  point: facePointsArr[i][j]
                })
                _this.drawLine({
                  el: faceCanvas,
                  points: [facePointsArr[i][j], facePointsArr[i][j - 1]]
                })
              }
            }
          }

          // 画垂直标准线
          for (let i = 0; i < verticalPointsArr.length; i++) {
            if (verticalPointsArr[i].x === 0 && verticalPointsArr[i].y === 0) {
              continue
            } else {
              cxt.save()
              cxt.strokeStyle = '#4db664'
              cxt.beginPath()
              cxt.moveTo(verticalPointsArr[i].x, 0)
              cxt.lineTo(verticalPointsArr[i].x, height)
              cxt.closePath()
              cxt.stroke()
              cxt.restore()

              cxt.save()
              cxt.fillStyle = '#fe610f'
              cxt.font = '30px serif'
              let windowWidth = document.documentElement.clientWidth
              let windowHeight = window.screen.height
              let offsetHeight = (windowHeight - 125) / (windowWidth / width)
              if (i === 0) {
                cxt.fillText('α', verticalPointsArr[i].x + 5, offsetHeight - 5)
              } else if (i === verticalPointsArr.length - 1) {
                cxt.fillText('γ', verticalPointsArr[i].x + 5, offsetHeight - 5)
              } else {
                cxt.fillText('β', verticalPointsArr[i].x + 5, offsetHeight - 5)
              }
              cxt.restore()
            }
          }

          // 画水平线
          let min = 99999
          let max = 0
          let indexOfKneeArr = []
          for (let i = 0; i < faceHorizontalArr.length; i++) {
            if (faceHorizontalArr[i].points.length !== 1) {
              if ((faceHorizontalArr[i].points[0].x === 0 && faceHorizontalArr[i].points[0].y === 0) ||
                (faceHorizontalArr[i].points[1].x === 0 && faceHorizontalArr[i].points[1].y === 0)) {
                continue
              }
              if (faceHorizontalArr[i].points[0].x < min) {
                min = faceHorizontalArr[i].points[0].x
              }
              if (faceHorizontalArr[i].points[1].x > max) {
                max = faceHorizontalArr[i].points[1].x
              }
            }

            if (faceHorizontalArr[i].key === 'legX' || faceHorizontalArr[i].key === 'legO' ||
              faceHorizontalArr[i].key === 'legXO') {
              indexOfKneeArr.push(i)
            }
          }

          // 将 x 型腿 和 O 型腿的角度合并在一起
          if (indexOfKneeArr.length === 2) {
            faceHorizontalArr[indexOfKneeArr[0]].secondRaw = faceHorizontalArr[indexOfKneeArr[1]].raw
            faceHorizontalArr.splice(indexOfKneeArr[1], 1)
          }

          for (let i = 0; i < faceHorizontalArr.length; i++) {
            _this.drawLineAndAngle({
              el: faceCanvas,
              angle: faceHorizontalArr[i].raw,
              secondAngle: faceHorizontalArr[i].secondRaw,
              points: faceHorizontalArr[i].points,
              min: min,
              max: max
            })
          }

          _this.$nextTick(function () {
            document.getElementById('face').appendChild(faceCanvas)
          })
        }
    
      },
      drawPoint (option) {
        let canvas = option.el
        let point = option.point
        let cxt = canvas.getContext('2d')
        cxt.save()
        cxt.fillStyle = '#009eff'
        cxt.beginPath()
        cxt.arc(point.x, point.y, 5, 0, 2 * Math.PI)
        cxt.closePath()
        cxt.fill()
        cxt.restore()
        cxt.save()
        cxt.fillStyle = 'rgba(83, 158, 255, .3)'
        cxt.beginPath()
        cxt.arc(point.x, point.y, 10, 0, 2 * Math.PI)
        cxt.closePath()
        cxt.fill()
        cxt.restore()
      },
      drawLine (option) {
        //console.log("option:",option)
        // 有一个点是x, y 都等于0的时候，不画线
        if ((option.points[0].x === 0 && option.points[0].y === 0) || (option.points[1].x === 0 && option.points[1].y === 0)) {
          return
        }
        let canvas = option.el
        let points = option.points
        let cxt = canvas.getContext('2d')
        cxt.save()
        cxt.lineWidth = 3
        if (!option.isSide) {
          cxt.strokeStyle = '#5f58f4'
          cxt.beginPath()
          cxt.moveTo(points[0].x, points[0].y)
          cxt.lineTo(points[1].x, points[1].y)
          cxt.closePath()
          cxt.stroke()
        } else {
          let _x = Math.abs(points[0].x - points[1].x)
          let _y = Math.abs(points[0].y - points[1].y)
          let z = Math.sqrt(Math.pow(_x, 2) + Math.pow(_y, 2))
          let startX
          let startY
          let endX
          let endY
          let distance = 80


          if (points[0].x > points[1].x) {
            startX = Math.round(points[1].x - distance * _x / z)
            startY = Math.round(points[1].y + distance * _y / z)
            endX = Math.round(points[0].x + distance * _x / z)
            endY = Math.round(points[0].y - distance * _y / z)
          } else {
            startX = Math.round(points[0].x - distance * _x / z)
            startY = Math.round(points[0].y - distance * _y / z)
            endX = Math.round(points[1].x + distance * _x / z)
            endY = Math.round(points[1].y + distance * _y / z)
          }

          cxt.strokeStyle = '#0ef8cd'
          cxt.beginPath()
          cxt.moveTo(startX, startY)
          cxt.lineTo(endX, endY)
          cxt.closePath()
          cxt.stroke()
        }

        cxt.restore()
      },
      drawRectAndAngle (option) {
        let cxt = option.cxt
        let angle = option.angle
        let point = option.point

        cxt.save()
        if (option.isSecond) {
          cxt.translate(0, 43)
        }
        cxt.save()
        cxt.fillStyle = 'rgba(100, 100, 98, 0.5)'
        cxt.beginPath()
        cxt.moveTo(point.x + 13, point.y + 3)
        cxt.lineTo(point.x + 99, point.y + 3)
        cxt.quadraticCurveTo(point.x + 109, point.y + 3, point.x + 109, point.y + 13)
        cxt.lineTo(point.x + 109, point.y + 33)
        cxt.quadraticCurveTo(point.x + 109, point.y + 43, point.x + 99, point.y + 43)
        cxt.lineTo(point.x + 13, point.y + 43)
        cxt.quadraticCurveTo(point.x + 3, point.y + 43, point.x + 3, point.y + 33)
        cxt.lineTo(point.x + 3, point.y + 13)
        cxt.quadraticCurveTo(point.x + 3, point.y + 3, point.x + 13, point.y + 3)
        cxt.closePath()
        cxt.fill()
        cxt.restore()

        // 绘制角度
        cxt.save()
        cxt.font = '34px Arial'
        cxt.fillStyle = '#0cfcca'
        cxt.textAlign = 'center'
        if (option.isTrunk) {
          cxt.fillText(`${angle}%`, point.x + 56, point.y + 38)
        } else {
          cxt.fillText(`${angle}°`, point.x + 56, point.y + 38)
        }
        cxt.restore()
        cxt.restore()
      },
      drawLineAndAngle (option) {
        let canvas = option.el
        let width = canvas.width
        let points = option.points
        let min = option.min - 100
        let max = option.max + 100
        let cxt = canvas.getContext('2d')

        // 如果有一个点不存在，则不画线
        for (let i = 0; i < points.length; i++) {
          if (points[i].x === 0 && points[i].y === 0) {
            return
          }
        }

        // 此处画脊柱侧弯

        if (points.length === 1) {
          this.drawRectAndAngle({
            cxt: cxt,
            angle: (option.angle * 100).toFixed(1),
            point: {
              x: width - 120,
              y: points[0].y
            },
            isSecond: false,
            isTrunk: true
          })
        } else {
          let _x = Math.abs(points[0].x - points[1].x)
          let _y = Math.abs(points[0].y - points[1].y)
          let startPoint = {}
          let endPoint = {}
          let offsetYL = Number(((points[0].x - min) * _y / _x).toFixed(0))
          let offsetYR = Number(((max - points[1].x) * _y / _x).toFixed(0))

          if (points[0].y < points[1].y) {
            startPoint.x = min
            startPoint.y = points[0].y - offsetYL
            endPoint.x = max
            endPoint.y = points[1].y + offsetYR
          } else {
            startPoint.x = min
            startPoint.y = points[0].y + offsetYL
            endPoint.x = max
            endPoint.y = points[1].y - offsetYR
          }

          cxt.save()
          cxt.strokeStyle = '#14bc9a'
          cxt.beginPath()
          cxt.moveTo(startPoint.x, startPoint.y)
          cxt.lineTo(endPoint.x, endPoint.y)
          cxt.closePath()
          cxt.stroke()
          cxt.restore()

          // 绘制圆角矩形框
          this.drawRectAndAngle({
            cxt: cxt,
            angle: option.angle.toFixed(1),
            point: {
              x: width - 120,
              y: points[1].y
            },
            isSecond: false
          })

          if (!_.isUndefined(option.secondAngle)) {
            this.drawRectAndAngle({
              cxt: cxt,
              angle: option.secondAngle.toFixed(1),
              point: {
                x: width - 120,
                y: points[1].y
              },
              isSecond: true
            })
          }
        }
      }
    },
    created () {
      this.initRiskPoints();
    },
}



// WEBPACK FOOTER //
// ./src/components/Posture_front.vue